<!-- Loading -->
<ng-container *ngIf="!ready">
  <div class="pt-loading">
    <div class="pt-loading__dots"><span></span><span></span><span></span></div>
  </div>
</ng-container>

<ng-container *ngIf="ready">

  <!-- Header -->
  <div class="dlg-hdr">
    <div class="dlg-hdr__title">
      <div class="dlg-hdr__icon-wrap">
        <mat-icon>people</mat-icon>
      </div>
      <div>
        <span>{{ uid ? 'Editar socio' : 'Nuevo socio' }}</span>
        <small class="dlg-hdr__sub" *ngIf="flagImport">Importación: {{ movement?.reference }}</small>
        <small class="dlg-hdr__sub" *ngIf="!flagImport && !uid">Completa los datos del socio</small>
        <small class="dlg-hdr__sub" *ngIf="!flagImport && uid">Modifica los datos del socio</small>
      </div>
    </div>
    <button mat-icon-button class="dlg-hdr__close" [mat-dialog-close] aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <mat-dialog-content class="pt-body">

    <!-- Importación banner -->
    <div class="pt-import-banner" *ngIf="flagImport">
      <mat-icon>file_download</mat-icon>
      <div>
        <span class="pt-import-banner__label">Título de importación</span>
        <span class="pt-import-banner__value">{{ movement?.reference }}</span>
      </div>
    </div>

    <!-- Sección: Identificación -->
    <div class="pt-section">
      <div class="pt-section__head">
        <mat-icon>person</mat-icon>
        <span>Identificación</span>
      </div>
      <div class="row g-3">

        <div class="col-12 col-sm-7">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nombre o Razón Social</mat-label>
            <mat-icon matPrefix>business</mat-icon>
            <input type="text" matInput required
              [formControl]="nameOrBusinessNameFormControl"
              [(ngModel)]="partnersModel.nameOrBusinessName"
              placeholder="Ej: Juan García, S.L.">
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-5">
          <app-input inputType="text" placeholder="Ej: 12345678A" [formControl]="vatNumberFormControl"></app-input>
        </div>

        <div class="col-12 col-sm-6">
          <app-autocomplete-select
            [items]="partnersExtras?.partnersTypes"
            [(selectedItemId)]="partnersModel.partnersTypesId"
            [idField]="'id'" [displayField]="'description'"
            placeholder="Tipo de socio">
          </app-autocomplete-select>
        </div>

        <div class="col-12 col-sm-6">
          <app-autocomplete-select
            [items]="partnersExtras?.partnersPosition"
            [(selectedItemId)]="partnersModel.partnersPositionId"
            [idField]="'id'" [displayField]="'description'"
            placeholder="Cargo">
          </app-autocomplete-select>
        </div>

      </div>
    </div>

    <!-- Sección: Participación -->
    <div class="pt-section">
      <div class="pt-section__head">
        <mat-icon>show_chart</mat-icon>
        <span>Participación</span>
      </div>
      <div class="row g-3">

        <div class="col-12 col-sm-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Participación %</mat-label>
            <mat-icon matPrefix>assignment</mat-icon>
            <input type="number" matInput
              [(ngModel)]="partnersModel.participation"
              [ngModelOptions]="{standalone: true}"
              placeholder="0.00">
            <span matSuffix class="pt-suffix">%</span>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Aporte</mat-label>
            <mat-icon matPrefix>attach_money</mat-icon>
            <input type="number" matInput
              [(ngModel)]="partnersModel.participationAmount"
              [ngModelOptions]="{standalone: true}"
              placeholder="0.00">
            <span matSuffix class="pt-suffix">€</span>
          </mat-form-field>
        </div>

        <div class="col-12 col-sm-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Remunerado</mat-label>
            <mat-icon matPrefix>work</mat-icon>
            <mat-select [(ngModel)]="partnersModel.remunerated" [ngModelOptions]="{standalone: true}">
              <mat-option [value]="true">Cargo remunerado</mat-option>
              <mat-option [value]="false">Cargo no remunerado</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

      </div>
    </div>

  </mat-dialog-content>

  <!-- Actions -->
  <mat-dialog-actions align="end" class="dlg-actions">
    <button mat-stroked-button type="button" (click)="closeDialog()">Cancelar</button>
    <button mat-flat-button class="pt-btn-save" type="button" (click)="onSubmit()" [disabled]="submitted">
      <mat-icon>save</mat-icon>
      {{ uid ? 'Guardar cambios' : 'Crear socio' }}
    </button>
  </mat-dialog-actions>

</ng-container>
